import React                from 'react'
import { inject, observer } from 'mobx-react'

import { DeleteButton     } from '../../components/delete'

export const DeletePartnerButton = inject('partnersStore')(observer(({partnersStore,entry}) =>
<DeleteButton tag="partner" title="partner.delete" onClick={partnersStore.remove(entry)} />))
